import { Box, BoxProps, combineSx } from '@chronosphereio/chrono-ui';

interface SeriesMarkerProps extends BoxProps {
  color: string;
  striped?: boolean;
}

const MARKER_WIDTH = 16;
const MARKER_MARGIN_RIGHT = 1.5;

export function SeriesMarker(props: SeriesMarkerProps) {
  const { color, striped, sx } = props;

  const background = striped
    ? `repeating-linear-gradient(
          90deg,
          ${color},
          ${color} 3px,
          transparent 3px,
          transparent 6px
        )`
    : color;
  return (
    <Box
      width={MARKER_WIDTH}
      sx={combineSx(
        {
          height: '4px',
          marginTop: 0,
          marginRight: MARKER_MARGIN_RIGHT,
          verticalAlign: 'text-top',
          background,
        },
        sx
      )}
    />
  );
}
